
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"IdeaTopCardTariffFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Investment_Idea"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TariffGridFragment"},"directives":[]}]}}],"loc":{"start":0,"end":132}};
    doc.loc.source = {"body":"#import 'components/TariffGrid/fragment.gql'\n\nfragment IdeaTopCardTariffFragment on Investment_Idea {\n  id\n  ...TariffGridFragment\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require('components/TariffGrid/fragment.gql').definitions));


      module.exports = doc;
    
